import { z } from '@bonanza-social/toolkit/api';
import { StatusSchema } from '../StatusService/StatusService.schemas';

export const StatusPerkTypeSchema = z.enum([
  'GemStones',
  'AccessToBetterRaf',
  'Cashback',
  'DailyWheel',
  'MultiplierOnLevelUp',
  'ShopWeeklyPromotion',
  'PriorityCustomerSupport',
  'StatusExclusiveGames',
  'VipHost',
]);

export const StatusPerkSchema = z.object({
  type: StatusPerkTypeSchema,
  value: z.number().optional(),
  title: z.string(),
  details: z.string(),
});

export const StatusPerksSchema = z.object({
  statusPerks: z.array(
    z.object({
      status: StatusSchema,
      perks: z.array(StatusPerkSchema),
      keepStatusBoxCount: z.number().optional(),
      promotionBoxCount: z.number().optional(),
    }),
  ),
});
